export function fileToString(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      if (event.target && event.target.result) {
        resolve(event.target.result as string);
      } else {
        reject(new Error('FileReader onload event triggered without result'));
      }
    };

    reader.onerror = (error) => {
      reject(new Error(`FileReader encountered an error: ${error}`));
    };

    reader.readAsText(file);
  });
}
